import { type OperationContext, type OperationResult, useMutation } from "urql"

import type {
  InstructionMutationBatchAddInstructionProductsArgs,
  InstructionMutationBatchDeleteInstructionProductsArgs,
  InstructionMutationCreateArgs,
  InstructionMutationUpdateArgs,
  Mutation,
} from "@/graphql/codegen/graphql"
import {
  AddProductsToInstructionDocument,
  CreateInstructionMutationDocument,
  RemoveProductsFromInstructionDocument,
  UpdateInstructionMutationDocument,
} from "@/graphql/codegen/graphql"

interface UseInstructionReturn {
  createInstruction: (
    variables: InstructionMutationCreateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "instruction">, InstructionMutationCreateArgs>>
  updateInstruction: (
    variables: InstructionMutationUpdateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "instruction">, InstructionMutationUpdateArgs>>
  addProducts: (
    variables: InstructionMutationBatchAddInstructionProductsArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "instruction">, InstructionMutationBatchAddInstructionProductsArgs>>
  removeProducts: (
    variables: InstructionMutationBatchDeleteInstructionProductsArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "instruction">, InstructionMutationBatchDeleteInstructionProductsArgs>>
}

export const useInstruction = (): UseInstructionReturn => {
  const [, createInstruction] = useMutation<Pick<Mutation, "instruction">, InstructionMutationCreateArgs>(
    CreateInstructionMutationDocument
  )

  const [, updateInstruction] = useMutation<Pick<Mutation, "instruction">, InstructionMutationUpdateArgs>(
    UpdateInstructionMutationDocument
  )

  const [, addProducts] = useMutation<
    Pick<Mutation, "instruction">,
    InstructionMutationBatchAddInstructionProductsArgs
  >(AddProductsToInstructionDocument)

  const [, removeProducts] = useMutation<
    Pick<Mutation, "instruction">,
    InstructionMutationBatchDeleteInstructionProductsArgs
  >(RemoveProductsFromInstructionDocument)

  return {
    createInstruction,
    updateInstruction,
    addProducts,
    removeProducts,
  }
}
